module.exports = function() {
  return new Worker("/" + "babel-transpiler.d114b8d6.worker.js");
};